import { render, staticRenderFns } from "./truckBox.vue?vue&type=template&id=f86204fe&"
import script from "./truckBox.vue?vue&type=script&lang=js&"
export * from "./truckBox.vue?vue&type=script&lang=js&"
import style0 from "./truckBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports